import { createSlice } from '@reduxjs/toolkit'
import { LocalStorageKeys, useLocalStorage } from 'shared/lib'

const { setItem, getItem } = useLocalStorage()

// Initial state for the global slice
const initialState = {
    isMenuOpen: true,
    isMobileMenuOpen: false,
    isUserProfileMobileMenuOpen: false,
    darkMode: false,
    showImage: JSON.parse(
        getItem(LocalStorageKeys.SHOW_PROFILE_PICTURE) || 'true'
    ),
    showUserImage: JSON.parse(
        getItem(LocalStorageKeys.SHOW_USER_IMAGE) || 'true'
    ),
}

/**
 * A slice for global UI state management.
 */
const globalSlice = createSlice({
    name: 'global',
    initialState,
    reducers: {
        /**
         * Toggles the state of the main menu.
         * @param state - The current state of the slice.
         */
        toggleMenu: (state) => {
            state.isMenuOpen = !state.isMenuOpen
        },
        /**
         * Toggles the state of the mobile menu.
         * @param state - The current state of the slice.
         */
        toggleMobileMenu: (state) => {
            state.isMobileMenuOpen = !state.isMobileMenuOpen
        },
        /**
         * Explicitly closes the mobile menu.
         * @param state - The current state of the slice.
         */
        closeMobileMenu: (state) => {
            state.isMobileMenuOpen = false
        },
        /**
         * Toggles the state of the user profile mobile menu.
         * @param state - The current state of the slice.
         */
        toggleUserProfileMobileMenu: (state) => {
            state.isUserProfileMobileMenuOpen =
                !state.isUserProfileMobileMenuOpen
        },
        /**
         * Explicitly closes the user profile mobile menu.
         * @param state - The current state of the slice.
         */
        closeUserProfileMobileMenu: (state) => {
            state.isUserProfileMobileMenuOpen = false
        },
        /**
         * Toggles the dark mode state.
         * @param state - The current state of the slice.
         */
        toggleDarkMode: (state) => {
            state.darkMode = !state.darkMode
        },
        /**
         * Toggles the state of showing the profile image.
         * @param state - The current state of the slice.
         * @param payload - The new state of showing the profile image.
         */
        toggleProfileImage: (state, payload) => {
            state.showImage = payload.payload
            setItem(LocalStorageKeys.SHOW_PROFILE_PICTURE, payload.payload)
        },
        /**
         * Toggles the state of showing the user image.
         * @param state - The current state of the slice.
         * @param payload - The new state of showing the user image.
         */
        toggleUserImage: (state, payload) => {
            state.showUserImage = payload.payload
            setItem(LocalStorageKeys.SHOW_USER_IMAGE, payload.payload)
        },
    },
})

export const {
    toggleMenu,
    toggleMobileMenu,
    closeMobileMenu,
    toggleUserProfileMobileMenu,
    closeUserProfileMobileMenu,
    toggleDarkMode,
    toggleProfileImage,
    toggleUserImage,
} = globalSlice.actions

export const globalReducer = globalSlice.reducer
